// API endpoints for posts
import { api } from './client';
import type { PublicationCategory } from '../types/common';
import type { UserTag } from '../lib/instagramTags';

export interface PostMedia {
  url: string;
  type: 'image' | 'video';
}

export interface Post {
  id: string;
  accountId: string;
  templateId?: string | null;
  media: PostMedia[];
  caption: string;
  status: 'draft' | 'published' | 'failed';
  instagramMediaId?: string;
  createdAt: string;
  updatedAt: string;
  publishedAt?: string;
  category?: PublicationCategory;
}

export interface CreatePostRequest {
  accountId: string;
  templateId?: string;
  media: PostMedia[];
  caption?: string;
  batchId?: string;
  category?: PublicationCategory;
  /** Account tags per media slide, aligned to `media` by index. */
  userTags?: UserTag[][];
  /** Up to 3 collaborator usernames (post-level). */
  collaborators?: string[];
}

export interface CreatePostResponse {
  post: Post;
}

export interface GetPostsResponse {
  posts: Post[];
}

export interface GetPostResponse {
  post: Post;
}

export interface PublishPostResponse {
  post: Post;
  /** Итог «Дублировать в сторис»; нет — сторис не просили. */
  story?: { status: 'success' | 'error'; error?: string };
}

export const postsApi = {
  /**
   * Получить все посты
   */
  getAll: () => api.get<GetPostsResponse>('/posts'),
  
  /**
   * Получить пост по ID
   */
  getById: (id: string) => api.get<GetPostResponse>(`/posts/${id}`),
  
  /**
   * Создать новый пост
   */
  create: (data: CreatePostRequest) => 
    api.post<CreatePostResponse>('/posts', data),
  
  /**
   * Обновить пост
   */
  update: (id: string, data: Partial<Post>) =>
    api.put<GetPostResponse>(`/posts/${id}`, data),
  
  /**
   * Удалить пост
   */
  delete: (id: string) => api.delete<{ success: boolean }>(`/posts/${id}`),
  
  /**
   * Опубликовать пост в Instagram
   */
  publish: (id: string, options?: { duplicateToStory?: boolean }) =>
    api.post<PublishPostResponse>(`/posts/${id}/publish`, options),
};